import { render } from "./AddKeywordNew.vue?vue&type=template&id=209d10dc&scoped=true"
import script from "./AddKeywordNew.vue?vue&type=script&lang=js"
export * from "./AddKeywordNew.vue?vue&type=script&lang=js"

import "./AddKeywordNew.vue?vue&type=style&index=0&id=209d10dc&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209d10dc"]])

export default __exports__